import axios from 'axios';
import { config } from '../config/api';

const AUTH_TOKEN_KEY = 'tradelab_token';
const AUTH_EXPIRY_KEY = 'tradelab_token_expiry';
const AUTH_EMAIL_KEY = 'tradelab_email';
const AUTH_NAME_KEY = 'tradelab_name';

interface LoginResponse {
  token: string;
  expiresAt: string;
  email: string;
  firstName: string;
}

export const authService = {
  login: async (email: string, password: string): Promise<LoginResponse> => {
    const response = await axios.post(`${config.apiBaseUrl}/Auth/login`, { email, password });
    const data: LoginResponse = response.data;
    localStorage.setItem(AUTH_TOKEN_KEY, data.token);
    localStorage.setItem(AUTH_EXPIRY_KEY, data.expiresAt);
    localStorage.setItem(AUTH_EMAIL_KEY, data.email);
    localStorage.setItem(AUTH_NAME_KEY, data.firstName || data.email);
    return data;
  },

  logout: () => {
    localStorage.removeItem(AUTH_TOKEN_KEY);
    localStorage.removeItem(AUTH_EXPIRY_KEY);
    localStorage.removeItem(AUTH_EMAIL_KEY);
    localStorage.removeItem(AUTH_NAME_KEY);
  },

  getToken: (): string | null => {
    return localStorage.getItem(AUTH_TOKEN_KEY);
  },

  getEmail: (): string | null => {
    return localStorage.getItem(AUTH_EMAIL_KEY);
  },

  getName: (): string | null => {
    return localStorage.getItem(AUTH_NAME_KEY);
  },

  isAuthenticated: (): boolean => {
    const token = localStorage.getItem(AUTH_TOKEN_KEY);
    const expiry = localStorage.getItem(AUTH_EXPIRY_KEY);
    if (!token || !expiry) return false;
    return new Date(expiry) > new Date();
  },
};
